/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useProcess } from "@/global-data";
import { useToast } from "@/hooks/use-toast";
import { getUserInfo } from "@/lib/token";
import { apiServices } from "@/services/api.services";
import { dashboard } from "@/services/global.services";
import { GenericType } from "@/types";
import { format } from "date-fns";
import { useEffect, useMemo, useState } from "react";
import { DateObject } from "react-multi-date-picker";
import { useNavigate } from "react-router-dom";

export const useMutations = () => {
  const [genericState, setGenericState] = useState({
    skelton: true,
    data: [],
    company: 0,
    snc_success: 0,
    erp_success: 0,
    erp_failed: 0,
    on_hold: 0,
    validation_failed: 0,
    failed: 0,
    duplicate: 0,
    total_processed_files: 0,
  });
  const { toast } = useToast();
  const { setProcess } = useProcess();
  const navigation = useNavigate();
  useEffect(() => {
    (async () => {
      await loadList();
      setGenericState((prev) => ({ ...prev, skelton: false }));
    })();
  }, []);

  const { company_id, user_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);

  const [dateRange, setDateRange] = useState<any>([
    new DateObject().subtract(4, "days"),
    new DateObject().add(4, "days"),
  ]);

  const onDateRange = async (prop: any) => {
    setDateRange(prop);
    const tempDates = [formatDate(prop[0]), formatDate(prop[1])];
    try {
      setProcess(true);
      await loadList(tempDates);
      setProcess(false);
    } catch (_error) {
      setProcess(false);
    }
  };

  const formatDate = (value: any) => {
    try {
      if (typeof value === "string" && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
        return value;
      }
      if (value?.toDate) {
        return format(value.toDate(), "dd-MM-yyyy");
      }
      return format(new Date(value as any), "dd-MM-yyyy");
    } catch (error) {
      return value;
    }
  };

  const loadList = async (prop?: any) => {
    let filterData: any = {};
    if (company_id !== "system") {
      filterData = { company_id: company_id };
    }

    let start = formatDate(dateRange[0]);
    let end = formatDate(dateRange[1]);

    if (prop) {
      start = formatDate(prop[0]);
      end = formatDate(prop[1]);
    }

    const payload = {
      data: {
        ...filterData,
        filter_by: {
          date_range: [start, end],
        },
      },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error } = await apiServices<GenericType>(
      dashboard.get,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status.message,
      });
    }

    if (data?.result?.metadata?.[dashboard?.key]) {
      console.log({ data: data?.result.metadata });
      const listData = data?.result?.metadata?.[dashboard?.key];
      setGenericState((prev) => ({
        ...prev,
        data: listData,
        company: listData.length,
        processed: listData.reduce(
          (sum: number, item: GenericType) =>
            sum + (item.total_processed_files || 0),
          0,
        ),
        snc_success: listData.reduce(
          (sum: number, item: GenericType) => sum + (item.snc_success || 0),
          0,
        ),
        erp_success: listData.reduce(
          (sum: number, item: GenericType) => sum + (item.erp_success || 0),
          0,
        ),
        erp_failed: listData.reduce(
          (sum: number, item: GenericType) => sum + (item.erp_failed || 0),
          0,
        ),
        on_hold: listData.reduce(
          (sum: number, item: GenericType) => sum + (item.on_hold || 0),
          0,
        ),
        validation_failed: listData.reduce(
          (sum: number, item: GenericType) =>
            sum + (item.validation_failed || 0),
          0,
        ),
        failed: listData.reduce(
          (sum: number, item: GenericType) => sum + (item.failed || 0),
          0,
        ),
        duplicate: listData.reduce(
          (sum: number, item: GenericType) => sum + (item.duplicate || 0),
          0,
        ),
        total_processed_files: listData.reduce(
          (sum: number, item: GenericType) =>
            sum + (item.total_processed_files || 0),
          0,
        ),
      }));
    }
  };

  const redirect = (prop: string, isDataExist?: number | undefined) => {
    const filter = JSON.stringify({ state: [prop] });
    if (isDataExist && company_id !== "system") {
      navigation(`/document?filter=${filter}`);
    }
  };

  return {
    genericState,
    redirect,
    company_id,
    dateRange,
    onDateRange,
  };
};
